import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import { listIotAgentUrl } from "../../config";
import api from "../../api";
import { IListIotAgent } from "../../common/types/iotAgentTypes";

const LIST_IOTAGENT: string = "listIotAgents";

const initialState: IListIotAgent = {
  message: null,
  status: Status.IDLE,
  error: null,
  values: null,
};
export const fetchIotData = createAsyncThunk(LIST_IOTAGENT, async () => {
  try {
    const listIotResponse = await api.get<IListIotAgent>(
      `${listIotAgentUrl}`
    );
    return listIotResponse.data;
  } catch (error) {
    throw error;
  }
});

const iotAgentSlice = createSlice({
  name: LIST_IOTAGENT,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIotData.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(fetchIotData.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.values = action.payload.values;
        state.message = action.payload.message;
      })
      .addCase(fetchIotData.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
      });
  },
});

type Selector = {
  listIotAgentApi: ReturnType<typeof iotAgentSlice.reducer>;
};

export const selector = (store: Selector) => store["listIotAgentApi"];

export default iotAgentSlice.reducer;
